var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"nav"},[_c('picture-cen-app')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }